import { jsPDF } from 'jspdf';

function hexToRgb(hex: string): [number, number, number] {
  const h = hex.replace('#', '');
  return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
}

const slug = (s: string) => s.toLowerCase().normalize('NFD').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

interface CertOpts { name: string; themeName: string; scoreLabel: string; accent: string; }

// Genereert en downloadt een A4-liggend certificaat-PDF (volledig client-side, anoniem).
export function downloadCertificate({ name, themeName, scoreLabel, accent }: CertOpts) {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
  const W = 297, H = 210, cx = W / 2;
  const [ar, ag, ab] = hexToRgb(accent);

  // Achtergrond (warm ivoor) + dubbele gouden kaderlijn
  doc.setFillColor(251, 248, 242); doc.rect(0, 0, W, H, 'F');
  doc.setDrawColor(194, 154, 51);
  doc.setLineWidth(1.2); doc.rect(12, 12, W - 24, H - 24);
  doc.setLineWidth(0.3); doc.rect(15.5, 15.5, W - 31, H - 31);

  // Merk
  doc.setFont('helvetica', 'bold'); doc.setFontSize(20); doc.setTextColor(23, 19, 14);
  doc.text('DigitalNext', cx, 42, { align: 'center' });
  doc.setDrawColor(194, 154, 51); doc.setLineWidth(0.6); doc.line(cx - 18, 48, cx + 18, 48);

  // Label
  doc.setFont('helvetica', 'normal'); doc.setFontSize(11); doc.setTextColor(138, 109, 18);
  doc.text('CERTIFICAAT VAN DEELNAME', cx, 70, { align: 'center', charSpace: 1.4 });

  // Naam (serif, groot)
  doc.setFont('times', 'bold'); doc.setFontSize(40); doc.setTextColor(23, 19, 14);
  doc.text(name, cx, 96, { align: 'center' });

  // Tekst
  doc.setFont('helvetica', 'normal'); doc.setFontSize(13); doc.setTextColor(51, 48, 43);
  doc.text(`heeft de toets van het thema “${themeName}”`, cx, 114, { align: 'center' });
  doc.text('met goed gevolg behaald.', cx, 122, { align: 'center' });

  // Score + datum
  doc.setFontSize(12); doc.setTextColor(107, 98, 88);
  doc.text(scoreLabel, cx, 140, { align: 'center' });
  const date = new Date().toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' });
  doc.text(`Behaald op ${date}`, cx, 148, { align: 'center' });

  // Accentstreep + voettekst
  doc.setDrawColor(ar, ag, ab); doc.setLineWidth(1.6); doc.line(cx - 28, 166, cx + 28, 166);
  doc.setFont('helvetica', 'normal'); doc.setFontSize(10); doc.setTextColor(154, 147, 138);
  doc.text('DigitalNext · een product van vrules.nl', cx, 186, { align: 'center' });

  doc.save(`certificaat-${slug(themeName)}.pdf`);
}
